import { isRequiredText, strMax } from '../../../utils';
export const clientQuestionValidate = {
    answer: [
        isRequiredText('回答を入力してください'),
        strMax(2000, '回答は2000文字以内で入力してください'),
    ],
};
export default clientQuestionValidate;
